import _ from "lodash";
import * as UI from "../framework/ui";
import * as Omnisearch from "../framework/components/omnisearch";
import * as Shortcuts from "../framework/shortcuts";

export function init() {
  const inputEl = document.querySelector("#app-omnisearch");
  if (inputEl === null) return;

  const resultsEl = document.querySelector("#app-search-results");
  const omnisearchEl = inputEl.closest(".omnisearch");

  initKeyboardNavigation(inputEl, omnisearchEl);
  initInputBehaviour(inputEl, resultsEl);

  const inputMobileEl = document.querySelector("#app-omnisearch-mobile");
  if (inputMobileEl === null) return;

  const resultsMobileEl = document.querySelector("#app-search-results-mobile");
  const omnisearchMobileEl = inputMobileEl.closest(".omnisearch");

  initKeyboardNavigation(inputMobileEl, omnisearchMobileEl);
  initInputBehaviour(inputMobileEl, resultsMobileEl);
}

function initKeyboardNavigation(inputEl, omnisearchEl) {
  const toggleInputFocus = () => {
    const isOpen = Omnisearch.toggle(omnisearchEl);
    if (isOpen) {
      inputEl.focus();
    } else {
      inputEl.blur();
    }
  };

  // Setup `/` and `Cmd/Ctrl + K` to focus the search input

  Shortcuts.add({
    key: "/",
    handle: toggleInputFocus,
  });

  Shortcuts.add({
    key: "k",
    metaKey: true,
    handle: toggleInputFocus,
  });
}

function initInputBehaviour(inputEl, resultsEl) {
  inputEl.addEventListener("focus", (_event) => search("", resultsEl), { once: true });

  inputEl.addEventListener(
    "input",
    _.debounce((event) => search(event.target.value, resultsEl), 300)
  );
}

function search(query, resultsEl) {
  UI.swap({
    url: p`/ajax/search?query=${query}`,
    container: resultsEl,
  });
}
